// extracted by mini-css-extract-plugin
export default {"projectFilterControl":"ProjectFilterControl_projectFilterControl__anYtp","label":"ProjectFilterControl_label__6tu4L"};